export default "__VITE_ASSET__BHFiCInx__"